/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsRecommendedProducts = {
  initReviewWidgets: function($container) {
    // Klaviyo Reviews star widgets need re-init after AJAX injection
    if (window.klReviewsObject && typeof window.klReviewsObject.renderWidgets === 'function') {
      window.klReviewsObject.renderWidgets();
    }

    // Judge.me preview badges on dynamically loaded thumbnails
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }

    // Shopify Product Reviews badges (if enabled)
    if (window.PXUTheme && window.PXUTheme.productReviews && typeof window.PXUTheme.productReviews.init === 'function') {
      window.PXUTheme.productReviews.init();
    }
  },
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsRecommendedProducts = $.extend(this, window.PXUTheme.getSectionData($section));

    // Look for an element with class 'product-recommendations'
    const $productRecommendations = $section.find('.product-recommendations');

    // Selectors
    const productID = $productRecommendations.data('product-id');
    const limit = $productRecommendations.data('limit');

    const sectionID = $productRecommendations.data('section-id');

    // If showing custom collection we do not want to build request url
    if (this.show_custom_collection) {
      this.showCustomCollection($section);
      return;
    }

    // Build request URL
    const shopURL = $productRecommendations.data('base-url');
    const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

    $.ajax({
      type: 'GET',
      url: requestUrl,
      success: function(data) {

        let $recommendedProductsElement = $(data).find('.product-recommendations').html();

        // Insert product list into the product recommendations container
        $productRecommendations.html($recommendedProductsElement);

        window.PXUTheme.jsProduct.relatedProducts();

        const refreshReviews = function() {
          window.PXUTheme.jsRecommendedProducts.initReviewWidgets($productRecommendations);
        };

        if (window.MCO && window.MCO.initSimpleColorSwatches) {
          window.MCO.initSimpleColorSwatches({
            container: $productRecommendations[0],
            productsPerRow: parseInt($productRecommendations.data('mco-products-per-row'), 10) || 3
          }).then(refreshReviews).catch(refreshReviews);
        } else {
          refreshReviews();
        }

        // Initialize shopify payment buttons
        if (Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        // Converting the currencies
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
      }
    });
  },
  setupRecommendedVideoPlayer: function($section) {
    const videosInRecommendedProducts = $section.find('[data-product-recommendations-container] [data-html5-video] video, [data-product-recommendations-container] [data-youtube-video]').get();

    // Only run Plyr.setup if videosInRecommendedProducts exists
    if (videosInRecommendedProducts.length > 0) {
      videosInRecommendedProductsPlayer = Plyr.setup(videosInRecommendedProducts, {
        controls: videoControls,
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
      if (videoPlayers !== null) {
        var combinedArray = videoPlayers.concat(videosInRecommendedProductsPlayer);
        videoPlayers = combinedArray;
      } else {
        videoPlayers = videosInRecommendedProductsPlayer;
      }
    }

    window.PXUTheme.jsVideo.setupListeners();
  },
  showCustomCollection: function($section) {
    const $recommendedProductsElement = $section.find('.product-recommendations').html();

    const $productRecommendationsContainer = $('.product-recommendations');
    $productRecommendationsContainer.html($recommendedProductsElement);

    window.PXUTheme.jsProduct.relatedProducts();

    const $container = $section.find('.product-recommendations');
    const refreshReviews = function() {
      window.PXUTheme.jsRecommendedProducts.initReviewWidgets($container);
    };

    if (window.MCO && window.MCO.initSimpleColorSwatches && $container.length) {
      window.MCO.initSimpleColorSwatches({
        container: $container[0],
        productsPerRow: parseInt($container.data('mco-products-per-row'), 10) || 3
      }).then(refreshReviews).catch(refreshReviews);
    } else {
      refreshReviews();
    }
  },
  unload: function($section) {
  }
}

/******/ })()
;